import React, { useEffect } from 'react';
import './Marketathon.css';
import CompanyLogo from '../Images/Assets/CompanyLogo.png';
import CurioKAARDSLogo from '../Images/Assets/n1.jpg';
import NSRCELLogo from '../Images/Sponsors/IIM.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCoins, 
  faTrophy, 
  faEnvelope, 
  faPhone, 
  faQuestionCircle, 
  faUsers, 
  faClock, 
  faCheck, 
  faStar, 
  faBullhorn, 
  faChalkboardTeacher, 
  faAward, 
  faCertificate, 
  faBriefcase, 
  faRocket, 
  faHandHoldingUsd, 
  faLink, 
} from '@fortawesome/free-solid-svg-icons';

const Marketathon = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="marketathon-container">
      <div className="marketathon-banner">
        <div className="banner-content">
          <div className="banner-text">            <h1>MARKETATHON 2025</h1>
            <p className="banner-subtitle">Advancing marketing innovation with creative strategies</p>
            <p className="banner-subtitle" style={{ fontStyle: 'italic', fontSize: '1.2em' }}>A 4-Week Marketing and Sales Innovation Challenge for Students</p>
            <a
            target="_blank"
            rel="noreferrer"
            href="https://forms.zohopublic.in/muthu32312gm1/form/MARKETATHONREGISTRATIONFORM/formperma/GjhCMcSdnEimVUfa0hP10WLQqPqXM_LpiRXwNc0NlCU" className="apply-now-btn">Apply now</a>
          </div>
        </div>
      </div>
      
      <div className="banner-partners">
        <div className="partner-logos">
          <img src={CompanyLogo} alt="Curiosense Innovations" className="partner-logo" />
          <img src={CurioKAARDSLogo} alt="CurioKAARDS" className="partner-logo" />
          <img src={NSRCELLogo} alt="NSRCEL IIMB" className="partner-logo" />
        </div>
      </div>

      <div className="marketathon-content">
        <div className="content-section">
          <div className="section-header">
            <FontAwesomeIcon icon={faQuestionCircle} className="section-icon" />
            <h2>WHAT IS MARKETATHON?</h2>
          </div>
          <p>Marketathon is a dynamic sales and marketing competition designed for students to showcase entrepreneurial skills by promoting innovative educational kits designed for pre-primary & primary education. Participants engage in creative marketing, sales, and teacher enrollment, blending strategy with hands-on experience. This challenge offers real-world marketing exposure, along with opportunities for awards, recognition, and internships.</p>

          <div className="section-header">
            <FontAwesomeIcon icon={faUsers} className="section-icon" />
            <h2>WHO CAN PARTICIPATE?</h2>
          </div>
          <ul className="eligibility-list">
            <li><FontAwesomeIcon icon={faCheck} className="list-icon" /> BBA/MBA Students (Marketing, Entrepreneurship, General Management)</li>
            <li><FontAwesomeIcon icon={faCheck} className="list-icon" /> B.Ed. Students (Aspiring Educators)</li>
            <li><FontAwesomeIcon icon={faCheck} className="list-icon" /> Any UG/PG Students who are passionate about startups, innovation, social impact or entrepreneurship — regardless of their stream or specialization</li>
            <li><FontAwesomeIcon icon={faCheck} className="list-icon" /> School Students (Grades 9 to 12) who are passionate about startups & social impact</li>
          </ul>
          <p>Students may participate individually or in teams of up to 3 members.</p>

          <div className="info-card">
            <FontAwesomeIcon icon={faClock} className="info-icon" />
            <h3>COMPETITION DURATION</h3>
            <p>4 weeks – counted from the participant's chosen start date after registration</p>
          </div>

          <div className="section-header">
            <FontAwesomeIcon icon={faBullhorn} className="section-icon" />
            <h2>WHAT WILL YOU PROMOTE?</h2>
          </div>
          <div className="promotion-items">
            <div className="promotion-item">
              <FontAwesomeIcon icon={faStar} className="promo-icon" />
              <div>
                <h4>CurioKAARDS</h4>
                <p>Game-based, curriculum-aligned interactive learning cards designed for early childhood and primary education. These cards make learning fun, engaging, and effective for young children.</p>
              </div>
            </div>
            <div className="promotion-item">
              <FontAwesomeIcon icon={faChalkboardTeacher} className="promo-icon" />
              <div>
                <h4>Teacher Enrolment</h4>
                <p>Encourage the enrolment of pre-primary and primary school teachers as formal evaluators of children to assess the learning outcomes and educational impact of CurioKAARDS.</p>
              </div>
            </div>
          </div>

          <div className="section-header">
            <FontAwesomeIcon icon={faRocket} className="section-icon" />
            <h2>HOW IT WORKS</h2>
          </div>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <p>Register (Solo or team of up to 3)</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <p>Attend 1-hour online orientation and receive a starter kit</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <p>Promote and sell to parents and schools and enroll teachers as evaluators</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <p>Submit marketing videos or strategies</p>
            </div>
            <div className="process-step">
              <div className="step-number">5</div>
              <p>Track your sales & collect additional kits</p>
            </div>
            <div className="process-step">
              <div className="step-number">6</div>
              <p>Win prizes, awards & certificate based on performance</p>
            </div>
          </div>

          <div className="section-header">
            <FontAwesomeIcon icon={faAward} className="section-icon" />
            <h2>AWARDS & RECOGNITION</h2>
          </div>

          <div className="awards-container">
            <div className="awards-category">
              <h3><FontAwesomeIcon icon={faHandHoldingUsd} className="category-icon" /> SALES-BASED AWARDS</h3>
              <ul className="awards-list">
                <li><span className="award-name">Top Impact Award</span> – Sale of 30+ Kits</li>
                <li><span className="award-name">Outstanding Contributor Award</span> – Sale of 20 to 29 Kits</li>
                <li><span className="award-name">Noteworthy Contributor Award</span> – Sale of 10 to 19 Kits</li>
                <li><span className="award-name">Emerging Achiever Award</span> – Sale of 3 to 9 Kits</li>
                <li><span className="award-name">Certified Education Ambassador</span> – Sale of 1–2 Kits</li>
              </ul>
            </div>

            <div className="awards-category">
              <h3><FontAwesomeIcon icon={faBullhorn} className="category-icon" /> MARKETING INNOVATION AWARDS</h3>
              <ul className="awards-list">
                <li><span className="award-name">Creative Marketing Visionary</span> – Most unique strategy</li>
                <li><span className="award-name">Digital Content Star</span> – Best promotional video</li>
                <li><span className="award-name">Social Impact Promoter</span> – Outreach with social value</li>
                <li><span className="award-name">Brand Storyteller Award</span> – Best storytelling in campaign</li>
              </ul>
            </div>

            <div className="awards-category">
              <h3><FontAwesomeIcon icon={faChalkboardTeacher} className="category-icon" /> TEACHER ENGAGEMENT AWARDS</h3>
              <div className="teacher-award">
                <h4>Teacher Outreach Excellence Award</h4>
                <p>Awarded to the participant or team that successfully enrols the highest number of pre-primary and primary school teachers as formal evaluators for CurioKAARDS. This award highlights leadership in expanding CurioKAARDS' impact in real classroom settings.</p>
              </div>
              <div className="teacher-award">
                <h4>Educator Network Builder Award</h4>
                <p>Presented for exceptional efforts in building meaningful collaborations with teachers and encouraging their active participation in assessing the learning outcomes of CurioKAARDS.</p>
              </div>
              <div className="additional-recognition">
                <h4>Additional Recognition</h4>
                <p>Winners will receive certificates of appreciation and may be considered for internship opportunities or bonus incentives from Curiosense Innovations.</p>
              </div>
            </div>
          </div>

          <div className="section-header">
            <FontAwesomeIcon icon={faTrophy} className="section-icon" />
            <h2>PRIZES & OPPORTUNITIES</h2>
          </div>
          <div className="prizes-container">
            <div className="prize-item">
              <FontAwesomeIcon icon={faCoins} className="prize-icon" />
              <div>
                <h4>AWARDS WITH CASH PRIZES</h4>
                <p>Top-performing individuals and teams will receive recognition including awards and attractive cash rewards up to ₹3,000 based on their sales performance, marketing innovation, and school teacher engagement efforts.</p>
              </div>
            </div>
            <div className="prize-item">
              <FontAwesomeIcon icon={faCertificate} className="prize-icon" />
              <div>
                <h4>DIGITAL CERTIFICATES</h4>
                <p>All participants will receive digital certificates of participation, with special distinctions for winners in each category.</p>
              </div>
            </div>
            <div className="prize-item">
              <FontAwesomeIcon icon={faBriefcase} className="prize-icon" />
              <div>
                <h4>INTERNSHIP OPPORTUNITIES</h4>
                <p>Selected winners may be offered internships with Curiosense Innovations Pvt Ltd, where they will gain hands-on experience in marketing, edtech, and business development.</p>
              </div>
            </div>
          </div>

          <div className="section-header">
            <FontAwesomeIcon icon={faRocket} className="section-icon" />
            <h2>WHY JOIN MARKETATHON?</h2>
          </div>
          <div className="benefits-list">
            <div className="benefit-item">
              <FontAwesomeIcon icon={faCheck} className="benefit-icon" />
              <p>Build marketing & sales skills – a crucial component in becoming a successful entrepreneur.</p>
            </div>
            <div className="benefit-item">
              <FontAwesomeIcon icon={faCheck} className="benefit-icon" />
              <p>Win awards and certificates</p>
            </div>
            <div className="benefit-item">
              <FontAwesomeIcon icon={faCheck} className="benefit-icon" />
              <p>Gain real-life exposure and networking</p>
            </div>
            <div className="benefit-item">
              <FontAwesomeIcon icon={faCheck} className="benefit-icon" />
              <p>Boost your resume and confidence</p>
            </div>
          </div>

          <div className="section-header">
            <FontAwesomeIcon icon={faRocket} className="section-icon" />
            <h2>READY TO COMPETE?</h2>
          </div>
          <div className="registration-info">
            <div className="reg-fee">
              <FontAwesomeIcon icon={faCoins} className="reg-icon" />
              <h3>REGISTRATION FEE</h3>
              <p>₹200 (Early Bird till 31st August 2025) / ₹290 thereafter</p>
            </div>
            <ul className="reg-includes">
              <li><FontAwesomeIcon icon={faCheck} className="include-icon" /> Includes 1 CurioKAARDS – game-based learning starter kit (for demo + first sale)</li>
              <li><FontAwesomeIcon icon={faCheck} className="include-icon" /> Orientation on sales & marketing strategies</li>
              <li><FontAwesomeIcon icon={faCheck} className="include-icon" /> Participation certificate upon successful completion of 4-weeks Marketathon</li>
              <li><FontAwesomeIcon icon={faCheck} className="include-icon" /> Eligibility for cash prizes, awards & internship opportunities based on performance.</li>
            </ul>
          </div>

          <div className="contact-info">
            <div className="contact-item">
              <FontAwesomeIcon icon={faLink} className="contact-icon" />
              <p>Register here: <a  target="_blank" rel="noreferrer" href="https://forms.zohopublic.in/muthu32312gm1/form/MARKETATHONREGISTRATIONFORM/formperma/GjhCMcSdnEimVUfa0hP10WLQqPqXM_LpiRXwNc0NlCU" className="contact-link">Registration Form</a></p>
            </div>
            <div className="contact-info-note">Registration open throughout the year.</div>
            <div className="contact-grid">
              <div className="contact-grid-item">
                <FontAwesomeIcon icon={faEnvelope} className="contact-grid-icon" />
                <p>contact@curiosense.co.in</p>
              </div>
              <div className="contact-grid-item">
                <FontAwesomeIcon icon={faLink} className="contact-grid-icon" />
                <p><a  target="_blank" rel="noreferrer" href="https://curiosense.co.in" className="contact-link">https://curiosense.co.in/</a></p>
              </div>
              <div className="contact-grid-item">
                <FontAwesomeIcon icon={faPhone} className="contact-grid-icon" />
                <p>+91 9901940345</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marketathon;